import { buildFileUrl } from '../apiConfig';

export function getAttachmentUrl(attachment) {
  return buildFileUrl(attachment?.url || attachment?.fileUrl || attachment?.path || '');
}

export function getAttachmentName(attachment, index = 0) {
  return attachment?.originalName || attachment?.title || attachment?.name || `فایل ${index + 1}`;
}

function getAttachmentCandidateName(attachment) {
  const fileName = getAttachmentName(attachment).toLowerCase();
  if (fileName.includes('.')) {
    return fileName;
  }

  const path = String(attachment?.url || attachment?.fileUrl || attachment?.path || '').toLowerCase();
  return path.split('/').pop()?.split('?')[0] || '';
}

export function inferAttachmentMimeType(attachment) {
  const candidate = getAttachmentCandidateName(attachment);

  if (candidate.endsWith('.pdf')) {
    return 'application/pdf';
  }

  if (candidate.endsWith('.docx')) {
    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }

  if (candidate.endsWith('.doc')) {
    return 'application/msword';
  }

  if (/\.(jpe?g|png|gif|webp|bmp|svg)$/.test(candidate)) {
    return 'image/*';
  }

  if (/\.(mp4|webm|ogg|mov|m4v)$/.test(candidate)) {
    return 'video/*';
  }

  if (attachment?.mimeType) {
    return attachment.mimeType;
  }

  return '';
}

export function isImageMimeType(mimeType = '') {
  return Boolean(mimeType?.startsWith('image/'));
}

export function isPdfMimeType(mimeType = '') {
  return mimeType === 'application/pdf';
}

export function isVideoMimeType(mimeType = '') {
  return Boolean(mimeType?.startsWith('video/'));
}

export function isDocxMimeType(mimeType = '') {
  return (
    mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    mimeType === 'application/vnd.ms-word.document.macroEnabled.12'
  );
}

export function isLegacyDocMimeType(mimeType = '') {
  return mimeType === 'application/msword';
}

export function isWordMimeType(mimeType = '') {
  return isDocxMimeType(mimeType) || isLegacyDocMimeType(mimeType);
}

export function formatAttachmentSize(bytes) {
  if (!bytes) {
    return '';
  }

  if (bytes < 1024) {
    return `${bytes} بایت`;
  }

  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} کیلوبایت`;
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} مگابایت`;
}
